import './translations';
let initialized = false;
export default function initialize() {
    if (initialized) {
        throw new Error('universal-ui already initialized');
    }
    initialized = true;
    // ...
}
